import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../Mycomponent/Assets/seoimg/logo.png";
// import "../css/header.css";
import { Logout } from "../../Mycomponent/share/upDater/constant";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import { Avatar, Button } from "@mui/material";
import { ZustandStore } from "../../store/zustand-store";
import IconButton from "@mui/material/IconButton";
import PhoneInTalk from "@mui/icons-material/PhoneInTalk";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Settings from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

import profileSvg from "../../admin/assets/sidebar/profile.svg";
import Divider from "@mui/material/Divider";

const Header = () => {
  const navigate = useNavigate();
  const { isSidebarOpen, setSidebarOpen } = ZustandStore((state) => state);
  const isLogin = useSelector((state) => state.loginout);

  const [anchorElMenu, setAnchorElMenu] = useState(null);
  const open = Boolean(anchorElMenu);

  const handleClick = (event) => {
    setAnchorElMenu(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElMenu(null);
  };

  const Profile = () => {
    navigate("/account");
  };

  return (
    <>
      <div className="navBar" style={{ backgroundColor: "rgb(247, 247, 247)" }}>
        <div className="d-flex w-100 h-100">
          <div className="top-bar-logo">
            <img src={logo} alt="RanksPro.io" />
          </div>
          <ul className="nv-ul ms-auto gap-2">
            <li className="flex-none-sm">
              <Link to={"https://help.rankspro.io/en"} target="_blank">
                <IconButton aria-label="chat">
                  <ChatBubbleOutlineIcon />
                </IconButton>
              </Link>
            </li>

            <li>
              {isLogin && (
                <div>
                  <Button
                    className="transform-off d-flex align-items-center gap-2"
                    id="basic-button"
                    aria-controls={open ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                  >
                    <img src={profileSvg} alt="profileSvg" />
                  </Button>

                  <Menu
                    anchorEl={anchorElMenu}
                    id="account-menu"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                  >
                    <MenuItem onClick={Profile}>
                      <ListItemIcon>
                        <AccountCircleIcon fontSize="small" />
                      </ListItemIcon>
                      Account
                    </MenuItem>
                    <MenuItem onClick={Logout}>
                      <ListItemIcon>
                        <LogoutIcon fontSize="small" />
                      </ListItemIcon>
                      Logout
                    </MenuItem>
                  </Menu>
                </div>
              )}
            </li>

            <li>
              <div className="top-bar_menu">
                {isSidebarOpen ? (
                  <CloseIcon
                    fontSize="large"
                    onClick={() => setSidebarOpen(false)}
                  />
                ) : (
                  <MenuIcon
                    fontSize="large"
                    onClick={() => setSidebarOpen(true)}
                  />
                )}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <Divider />
    </>
  );
};

export default Header;
